import './core-hop';

import {mixin as arrayUtils} from './services/array-utils';
import {mixin as dateFormatter} from './services/date-format';
import {mixin as httpClient} from './services/http-client';
import {mixin as storage} from './services/storage';

const Hop = window.Hop;

Hop.support = Hop.support || {};
Hop.supportFn = Hop.supportFn || {};

const testDraganddrop = function () {
    const div = document.createElement('div');
    return 'draggable' in div || ('ondragstart' in div && 'ondrop' in div);
};

Hop.support.draganddrop = testDraganddrop();

/* test-code */
Hop._test = {};
/* end-test-code */

if ($('html').hasClass('csstransitions')) {
    jQuery.fx.off = true;
}

arrayUtils(Hop);
storage(Hop);
httpClient(Hop);

dateFormatter(Hop);

Hop.hasFormValidation = function () {
    return 'noValidate' in document.createElement('form');
};

function testDate(outdated) {
    try {
        if (Hop.sessionStorage.getItem('sessionBrowserTest') === null) {
            const browser = Hop.getBrowserDesc();

            const limitDate = browser.msie && browser.version < 9 ? 2 : 4;
            if (Hop.localStorage.getItem('browserTest') === null && outdated) {
                Hop.sessionStorage.setItem('sessionBrowserTest', 'true');
                Hop.localStorage.setItem('browserTest', new Date().toString());
                return true;
            }
            Hop.sessionStorage.setItem('sessionBrowserTest', 'true');
            const oldDate = new Date(Hop.localStorage.getItem('browserTest'));
            const date = new Date();
            const timeDiff = Math.abs(oldDate.getTime() - date.getTime());
            const diffDay = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return diffDay > limitDate;
        } else {
            return false;
        }
    } catch (e) {
        if (Hop.getCookie('oldbrowser') === '') {
            Hop.setCookie('oldbrowser', 'ok', {expiresInDays: 1});
            return true;
        }
    }
}

function getLang() {
    const htmlLang = $('html').attr('lang') || 'en';
    const langs = ['br', 'cn', 'cz', 'de', 'ee', 'en', 'es', 'fa', 'fi', 'fr', 'hu', 'id', 'it', 'lt', 'nl', 'pl', 'pt', 'ro', 'ru', 'si', 'ua'];

    const lang = htmlLang.match(/\D\D/);

    if (lang === null || $.inArray(lang[0], langs) === -1) {
        return 'en';
    } else {
        return lang[0];
    }
}

Hop.getLang = getLang;

function browserTest() {
    if (window.navigator.userAgent.indexOf('Node.js') === 0) {
        return;
    }

    const browser = Hop.getBrowserDesc();
    const outdated = Hop.isOutdatedBrowser();

    if (testDate(outdated)) {
        window.outdatedBrowser({
            bgColor: '#f25648',
            color: '#ffffff',
            lowerThan: outdated && !browser.msie ? 'false' : 'borderImage',
            languagePath: '/assets/vendor/outdatedbrowser/outdatedbrowser/lang/' + getLang() + '.html',
        });

        if (document.getElementById('outdated')) {
            const outdatedInter = setInterval(() => {
                const $btnUpdateBrowser = $('#btnUpdateBrowser');
                if ($btnUpdateBrowser.length) {
                    $btnUpdateBrowser.attr('href', 'http://browsehappy.com/?locale=' + getLang()).attr('target', '_blank');
                    clearInterval(outdatedInter);
                }
            }, 500);
        }
    }

    if (browser.safari && browser.version < 6) {
        const svg = document.querySelectorAll('.svg');
        for (let i = 0; i < svg.length; i++) {
            svg[i].setAttribute('src', svg[i].src.replace('svg', 'png'));
        }
    }
}

$(() => {
    Hop.oldscrollTop = null;

    $('.modal')
        .on('show.bs.modal', function () {
            // $('body').css({"padding-right": ''});
            $('html').addClass('modal-open-for-html');

            // eslint-disable-next-line no-invalid-this
            const el = this;

            Hop.control.init(el);

            if (el.querySelectorAll('.lazy').length && typeof window.Echo === 'object') {
                window.Echo.render(true);
            }
        })
        .on('hidden.bs.modal', function () {
            $('html').removeClass('modal-open-for-html');

            if ($('.modal.in').length) {
                $('html').addClass('modal-open-for-html');
                $('body').addClass('modal-open');
            }

            // eslint-disable-next-line no-invalid-this
            const el = this;

            Hop.control.destroy(el);
        });

    Hop.control.init();

    browserTest();

    if (window.location.hash !== '') {
        const oMenu = Hop.getStoreObj('menu');
        if (oMenu) {
            $(oMenu.root).on('stickyopen', () => {
                $(oMenu.root).off('stickyopen');
                let $elReferencedByHash;
                try {
                    $elReferencedByHash = $(window.location.hash);
                } catch (e) {
                    if (e.toString().indexOf('unrecognized expression') === -1) {
                        throw e;
                    }
                    // else swallow it, we can't do anything about invalid hashes here, especially when entered by users
                }
                if ($elReferencedByHash && $elReferencedByHash.length) {
                    $('html, body').animate(
                        {
                            scrollTop: $elReferencedByHash.offset().top - oMenu.hmenu,
                        },
                        500,
                    );
                }
            });
        }
    }
});
